<template>
  <v-menu
    open-on-hover
    location="bottom right"
    :open-delay="300"
    :close-delay="100"
  >
    <template #activator="{ props }">
      <div
        v-bind="props"
      >
        <v-btn
          icon
          size="x-small"
          class="lock-icon"
          :class="{
            active: isActive,
            'no-pointer': !isEditable,
          }"
          @click="$emit('click', $event)"
        >
          <IconLock1 v-if="isEditable && !isActive" />
          <IconLock3 v-else />
        </v-btn>
      </div>
    </template>

    <div
      v-if="!isEditable || isTemplate || isFlagship"
      class="tooltip text-textDarkest"
    >
      <h5 v-if="!isTemplate && !isFlagship">
        Locked Content
      </h5>
      <p
        v-if="isTemplate"
        class="mt-2"
      >
        This content will be locked for any jobs created using this template
      </p>
      <p
        v-else-if="isFlagship"
        class="mt-2"
      >
        This content will be locked for any jobs created using this flagship
      </p>
      <p
        v-else
        class="mt-2"
      >
        This content is locked from your template by your account admin
      </p>
    </div>
  </v-menu>
</template>

<script>
import IconLock1 from '@ui/assets/icons/Icon_Lock1.svg?component';
import IconLock3 from '@ui/assets/icons/Icon_Lock3.svg?component';

export default {
  name: 'LockIcon',
  components: { IconLock1, IconLock3 },
  props: {
    isActive: { type: Boolean, default: false },
    isEditable: { type: Boolean, default: false },
    isTemplate: { type: Boolean, default: false },
    isFlagship: { type: Boolean, default: false },
  },
  emits: ['click'],
};
</script>

<style scoped lang="less">
.lock-icon {
  height: 20px;
  width: 20px;
  border-radius: 2px;
  box-shadow: inset 0 0 0 1px fade(@bg-brand-default, 40%);

  &.active {
    background-color: fade(@bg-brand-default, 10%);
  }
  &.no-pointer {
    cursor: initial;
  }

  svg {
    margin: 5px 6px;
    width: 8px;
    height: 10px;
    fill: fade(@bg-brand-default, 40%);
  }
}

.tooltip {
  z-index: 10;
  position: absolute;
  top: 0;
  left: 0;
  width: 208px;
  background: @white;
  border-radius: 8px;
  box-shadow: 0 0 50px fade(@text-darkest, 10%);
  text-align: center;
  padding: 24px;
}
</style>
